import type { UserRole } from "app/UtilitiesAndConstants/UtilityFunctions/userRoleUtils";

export enum ELimitationType {
    SOFT = "Soft",
    HARD = "Hard",
}

export interface IMeteringRawData {
    Count: number;
    Type: string;
    UserRole: UserRole;
}

export interface IMeteringState {
    textState: EMeteringCountRatio;
    limitationType: ELimitationType;
}

export interface IMeteringData {
    count: number;
    allowedNum: number;
    allowedHardLimitation?: number;
    isAdmin?: boolean;
}

export type GetMeteringData = (data: IMeteringRawData) => IMeteringData | undefined;

export enum EMeteringCountRatio {
    ADMIN_BELOW_80,
    ADMIN_BELOW_100,
    ADMIN_EQUAL_100,
    ADMIN_ABOVE_100,
    BELOW_80,
    BELOW_100,
    EQUAL_100,
    ABOVE_100,
    CUSTOM_15_000,
    HARD_ADMIN_BELOW_80,
    HARD_ADMIN_BELOW_100,
    HARD_ADMIN_EQUAL_100,
    HARD_ADMIN_EQUAL_100_PLUS_1,
    HARD_ADMIN_ABOVE_100_PLUS_2,
    HARD_BELOW_80,
    HARD_BELOW_100,
    HARD_EQUAL_100,
    HARD_EQUAL_100_PLUS_1,
    HARD_ABOVE_100_PLUS_2,
}

export type MeteringStateToTitleMap = Partial<Record<EMeteringCountRatio, string>>;
